/* eslint-disable @typescript-eslint/no-explicit-any */
import type { PropTypes } from '@material-ui/core';
import { capitalize } from '@material-ui/core';
import MuiButton from '@material-ui/core/Button';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import clsx from 'clsx';
import React from 'react';
import useStyles from './Button.styles';
import type { ButtonProps, OverridableButton } from './Button.types';

const Button = <C extends React.ElementType>(props: ButtonProps<C, { component?: C }>): JSX.Element => {
    const { children, component, className, color = 'default', disabled, shape, loading, variant, ...rest } = props;
    const colorMapping = `${variant}${capitalize(color)}`;
    const isDefault = ['default', 'inherit', 'primary', 'secondary'].includes(color);
    const propColor = isDefault ? (color as PropTypes.Color) : 'default';
    const classes = useStyles();

    return (
        <MuiButton
            component={component}
            color={propColor}
            variant={variant}
            disabled={disabled || loading}
            className={clsx(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                { [classes[colorMapping]]: !isDefault && color !== 'inherit' },
                { [classes.shape]: shape === 'circle' || shape === 'square' },
                { [classes.circle]: shape === 'circle' },
                className,
            )}
            {...rest}
        >
            <div className={clsx(classes.label, loading && classes.labelHidden)}>{children}</div>
            {loading && <MuiCircularProgress size={24} className={classes.progress} />}
        </MuiButton>
    );
};

export default Button as OverridableButton;
